import { userConstants } from './constantData';

const playerCommonDimensions = [
  'v_content_name', /* 17 */
  'v_content_type', /* 18 */
  'v_content_id', /* 19 */
  'v_genre', /* 20 */
  'v_play_source', /* 21 */
  'v_start_progress_bar', /* 22 */
  'v_video_subtitle', /* 27 */
  'v_video_language', /* 28 */
  'v_transmission_type', /* 34 */
  'v_content_player_type', /* 53 */
  'v_is_sports', /* 66 */
  'v_video_duration', /* 100 */
];

const pageViewCommonDimensions = [
  'v_section_name', /* 31 */
  'v_provider_name', /* 35 */
  'v_collection_name', /* 36 */
  'v_component_type', /* 42 */
  'v_start_video_percentual', /* 104 */
];

export const PLAYER_MOVIE_SERIE_LIVE_DATA = {
  player_movie: {
    page_view: {
      hash: 'p-001.002.000.000.000.000',
      event: 'pages',
      dimensions: [...userConstants,
        ...playerCommonDimensions,
        ...pageViewCommonDimensions,
        'v_content_age_rating', /* 74 */
        'v_age_restricted_content', /* 75 */
        'v_source',
      ],
    },
    watch_from_beginning: {
      hash: 'e-001.002.001.000.000.176',
      event: 'interactions',
      dimensions: [...userConstants,
        ...playerCommonDimensions,
        'v_change_progress',
        'v_change_progress_percentual',
      ],
    },
    language: {
      hash: 'e-001.002.001.000.000.021',
      event: 'interactions',
      dimensions: [...userConstants,
        ...playerCommonDimensions,
        'v_change_progress',
        'v_change_progress_percentual',
      ],
    },
    pause: {
      hash: 'e-001.002.001.000.000.017',
      event: 'interactions',
      dimensions: [...userConstants,
        ...playerCommonDimensions,
        'v_change_progress',
        'v_change_progress_percentual',
      ],
    },
    play: {
      hash: 'e-001.002.001.000.000.027',
      event: 'interactions',
      dimensions: [...userConstants,
        ...playerCommonDimensions,
        'v_change_progress',
        'v_change_progress_percentual',
      ],
    },
    backward: {
      hash: 'e-001.002.001.000.000.016',
      event: 'interactions',
      dimensions: [...userConstants,
        ...playerCommonDimensions,
        'v_change_progress',
        'v_change_progress_percentual',
      ],
    },
    forward: {
      hash: 'e-001.002.001.000.000.018',
      event: 'interactions',
      dimensions: [...userConstants,
        ...playerCommonDimensions,
        'v_change_progress',
        'v_change_progress_percentual',
      ],
    },
    close: {
      hash: 'e-001.002.001.000.000.008',
      event: 'interactions',
      dimensions: [...userConstants,
        ...playerCommonDimensions,
        'v_finish_progress_bar',
        'v_finish_progress_percentual',
      ],
    },
  },
  player_serie: {
    page_view: {
      hash: 'p-001.003.000.000.000.000',
      event: 'pages',
      dimensions: [...userConstants,
        ...playerCommonDimensions,
        ...pageViewCommonDimensions,
        'v_serie_name',
        'v_season',
        'v_episode_number',
        'v_episode_name',
        'v_content_age_rating', /* 74 */
        'v_age_restricted_content', /* 75 */
        'v_source',
      ],
    },
    watch_from_beginning: {
      hash: 'e-001.003.001.000.000.176',
      event: 'interactions',
      dimensions: [...userConstants,
        ...playerCommonDimensions,
        'v_serie_name',
        'v_season',
        'v_episode_number',
        'v_episode_name',
        'v_change_progress',
        'v_change_progress_percentual',
      ],
    },
    next_episode: {
      hash: 'e-001.003.001.000.000.014',
      event: 'interactions',
      dimensions: [...userConstants,
        ...playerCommonDimensions,
        'v_serie_name',
        'v_season',
        'v_episode_number',
        'v_episode_name',
        'v_change_progress',
        'v_change_progress_percentual',
      ],
    },
    next_episode_load: {
      hash: 'e-001.003.003.000.000.015',
      event: 'interactions',
      dimensions: [...userConstants,
        ...playerCommonDimensions,
        'v_serie_name',
        'v_season',
        'v_episode_number',
        'v_episode_name',
        'v_change_progress',
        'v_change_progress_percentual',
      ],
    },
    language: {
      hash: 'e-001.003.001.000.000.021',
      event: 'interactions',
      dimensions: [...userConstants,
        ...playerCommonDimensions,
        'v_serie_name',
        'v_season',
        'v_episode_number',
        'v_episode_name',
        'v_change_progress',
        'v_change_progress_percentual',
      ],
    },
    pause: {
      hash: 'e-001.003.001.000.000.017',
      event: 'interactions',
      dimensions: [...userConstants,
        ...playerCommonDimensions,
        'v_serie_name',
        'v_season',
        'v_episode_number',
        'v_episode_name',
        'v_change_progress',
        'v_change_progress_percentual',
      ],
    },
    play: {
      hash: 'e-001.003.001.000.000.027',
      event: 'interactions',
      dimensions: [...userConstants,
        ...playerCommonDimensions,
        'v_serie_name',
        'v_season',
        'v_episode_number',
        'v_episode_name',
        'v_change_progress',
        'v_change_progress_percentual',
      ],
    },
    backward: {
      hash: 'e-001.003.001.000.000.016',
      event: 'interactions',
      dimensions: [...userConstants,
        ...playerCommonDimensions,
        'v_serie_name',
        'v_season',
        'v_episode_number',
        'v_episode_name',
        'v_change_progress',
        'v_change_progress_percentual',
      ],
    },
    forward: {
      hash: 'e-001.003.001.000.000.018',
      event: 'interactions',
      dimensions: [...userConstants,
        ...playerCommonDimensions,
        'v_serie_name',
        'v_season',
        'v_episode_number',
        'v_episode_name',
        'v_change_progress',
        'v_change_progress_percentual',
      ],
    },
    close: {
      hash: 'e-001.003.001.000.000.008',
      event: 'interactions',
      dimensions: [...userConstants,
        ...playerCommonDimensions,
        'v_serie_name',
        'v_season',
        'v_episode_number',
        'v_episode_name',
        'v_finish_progress_bar',
        'v_finish_progress_percentual',
      ],
    },
  },
  player_live: {
    page_view: {
      hash: 'p-001.005.000.000.000.000',
      event: 'pages',
      dimensions: [...userConstants,
        ...playerCommonDimensions,
        ...pageViewCommonDimensions,
        'v_channel_name',
        'v_serie_name',
        'v_season',
        'v_channel_id',
        'v_episode_number',
        'v_episode_name',
        'v_content_age_rating', /* 74 */
        'v_age_restricted_content', /* 75 */
        'v_is_betting', /* 81 */
        'v_source',
      ],
    },
    live: {
      hash: 'e-001.005.001.000.000.020',
      event: 'interactions',
      dimensions: [...userConstants,
        ...playerCommonDimensions,
        'v_channel_name',
        'v_serie_name',
        'v_season',
        'v_channel_id',
        'v_episode_number',
        'v_episode_name',
        'v_change_progress',
        'v_change_progress_percentual',
      ],
    },
    more_channels: {
      hash: 'e-001.005.001.000.000.169',
      event: 'interactions',
      dimensions: [...userConstants,
        ...playerCommonDimensions,
        'v_channel_name',
        'v_serie_name',
        'v_season',
        'v_channel_id',
        'v_episode_number',
        'v_episode_name',
        'v_change_progress',
        'v_change_progress_percentual',
      ],
    },
    language: {
      hash: 'e-001.005.001.000.000.021',
      event: 'interactions',
      dimensions: [...userConstants,
        ...playerCommonDimensions,
        'v_channel_name',
        'v_serie_name',
        'v_season',
        'v_channel_id',
        'v_episode_number',
        'v_episode_name',
        'v_change_progress',
        'v_change_progress_percentual',
      ],
    },
    pause: {
      hash: 'e-001.005.001.000.000.017',
      event: 'interactions',
      dimensions: [...userConstants,
        ...playerCommonDimensions,
        'v_channel_name',
        'v_serie_name',
        'v_season',
        'v_channel_id',
        'v_episode_number',
        'v_episode_name',
        'v_change_progress',
        'v_change_progress_percentual',
      ],
    },
    play: {
      hash: 'e-001.005.001.000.000.027',
      event: 'interactions',
      dimensions: [...userConstants,
        ...playerCommonDimensions,
        'v_channel_name',
        'v_serie_name',
        'v_season',
        'v_channel_id',
        'v_episode_number',
        'v_episode_name',
        'v_change_progress',
        'v_change_progress_percentual',
      ],
    },
    backward: {
      hash: 'e-001.005.001.000.000.016',
      event: 'interactions',
      dimensions: [...userConstants,
        ...playerCommonDimensions,
        'v_channel_name',
        'v_serie_name',
        'v_season',
        'v_channel_id',
        'v_episode_number',
        'v_episode_name',
        'v_change_progress',
        'v_change_progress_percentual',
      ],
    },
    forward: {
      hash: 'e-001.005.001.000.000.018',
      event: 'interactions',
      dimensions: [...userConstants,
        ...playerCommonDimensions,
        'v_channel_name',
        'v_serie_name',
        'v_season',
        'v_channel_id',
        'v_episode_number',
        'v_episode_name',
        'v_change_progress',
        'v_change_progress_percentual',
      ],
    },
    close: {
      hash: 'e-001.005.001.000.000.008',
      event: 'interactions',
      dimensions: [
        ...userConstants,
        ...playerCommonDimensions,
        'v_channel_name',
        'v_serie_name',
        'v_season',
        'v_channel_id',
        'v_episode_number',
        'v_episode_name',
        'v_finish_progress_bar',
        'v_finish_progress_percentual',
      ],
    },
    interactivity: {
      hash: 'e-001.005.001.000.000.264',
      event: 'interactions',
      dimensions: [
        ...userConstants,
        ...playerCommonDimensions,
        'v_channel_name', /* 23 */
        'v_channel_id', /* 50 */
        'v_change_progress', /* 57 */
        'v_change_progress_percentual', /* 105 */
      ],
    },
    tappp_panel: {
      hash: 'p-002.156.000.000.000.000',
      event: 'pages',
      dimensions: [
        ...userConstants,
        ...playerCommonDimensions,
        'v_channel_name', /* 23 */
        'v_channel_id', /* 50 */
        'v_content_age_rating', /* 74 */
        'v_age_restricted_content', /* 75 */
        'v_change_progress_percentual', /* 105 */
      ],
    },
  },
  player_audio_and_subtitles: {
    change_audio: {
      hash: 'e-001.004.004.000.000.030',
      event: 'interactions',
      dimensions: [
        ...userConstants,
        'v_content_name',
        'v_content_type',
        'v_content_id',
        'v_genre',
        'v_play_source',
        'v_start_progress_bar',
        'v_channel_name',
        'v_serie_name',
        'v_season',
        'v_video_language',
        'v_channel_id',
        'v_episode_number',
        'v_episode_name',
        'v_transmission_type',
        'v_content_player_type',
        'v_change_progress',
        'v_is_sports',
        'v_video_duration',
        'v_change_progress_percentual',
      ],
    },
    change_subtitle: {
      hash: 'e-001.004.005.000.000.030',
      event: 'interactions',
      dimensions: [
        ...userConstants,
        'v_content_name',
        'v_content_type',
        'v_content_id',
        'v_genre',
        'v_play_source',
        'v_start_progress_bar',
        'v_channel_name',
        'v_serie_name',
        'v_season',
        'v_video_subtitle',
        'v_channel_id',
        'v_episode_number',
        'v_episode_name',
        'v_transmission_type',
        'v_content_player_type',
        'v_change_progress',
        'v_is_sports',
        'v_video_duration',
        'v_change_progress_percentual',
      ],
    },
    close: {
      hash: 'e-001.004.001.000.000.008',
      event: 'interactions',
      dimensions: [
        ...userConstants,
        'v_content_name',
        'v_content_type',
        'v_content_id',
        'v_genre',
        'v_play_source',
        'v_start_progress_bar',
        'v_channel_name',
        'v_serie_name',
        'v_season',
        'v_channel_id',
        'v_episode_number',
        'v_episode_name',
        'v_transmission_type',
        'v_content_player_type',
        'v_finish_progress_bar',
        'v_is_sports',
        'v_video_duration',
        'v_change_progress_percentual',
      ],
    },
  },
  player_error: {
    page_view: {
      hash: 'p-041.023.000.000.000.000',
      event: 'pages',
      dimensions: [
        ...userConstants,
        'v_error_code',
        'v_error_type',
        'v_content_name', /* 17 */
        'v_content_type', /* 18 */
        'v_content_id', /* 19 */
        'v_genre', /* 20 */
      ],
    },
    page_view_ppv: {
      hash: 'p-041.023.000.000.000.000',
      event: 'pages',
      dimensions: [
        ...userConstants,
        'v_error_code',
        'v_error_type',
        'v_campaign_name',
        'v_content_name', /* 17 */
        'v_content_type', /* 18 */
        'v_content_id', /* 19 */
        'v_genre', /* 20 */
      ],
    },
    ya_compre_ppv: {
      hash: 'e-041.023.001.000.000.265',
      event: 'interactions',
      dimensions: [
        ...userConstants,
        'v_error_code',
        'v_error_type',
        'v_campaign_name',
      ],
    },
    ok: {
      hash: 'e-041.023.001.000.000.154',
      event: 'interactions',
      dimensions: [
        ...userConstants,
        'v_error_code',
        'v_error_type',
      ],
    },
    close: {
      hash: 'e-041.023.001.000.000.008',
      event: 'interactions',
      dimensions: [
        ...userConstants,
        'v_error_code',
        'v_error_type',
      ],
    },
  },
};
